module.exports = __webpack_public_path__ + "static/media/amazon.61772f80.svg";